export const CREATE = "books/create";
export const RETRIEVE = "books/retrieve";
export const UPDATE = "books/update";
export const DELETE = "books/delete";
